import {
  APP_BOOTSTRAP_LISTENER,
  ModuleWithProviders,
  NgModule,
  inject,
  provideAppInitializer,
} from "@angular/core";
import {
  SharedModule,
  SelfServMetaCache,
  SelfServAnalyticsService,
} from "@aa/selfserv/shared";
import { AppConfig } from "@aa/common";

import { environment } from "../../environments/environment";

export function appInitializer(appConfig: AppConfig): () => void {
  return () => appConfig.init("selfserv", environment);
}

export function selfServMeta(metaCache: SelfServMetaCache): () => void {
  return () => metaCache.init(environment.selfServDomain);
}

// null bootstrap function which is used force DI to generate singleton services
// we don't need to use the args
export function serviceBootstrap(): () => void {
  return () => null;
}

// list of services which must be instantiated after bootstrap
const STARTUP_SERVICES = [SelfServAnalyticsService];

@NgModule({
  imports: [SharedModule],
  declarations: [],
  exports: [],
})
export class CoreModule {
  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        provideAppInitializer(() => {
          const initializerFn = appInitializer(inject(AppConfig));
          return initializerFn();
        }),
        provideAppInitializer(() => {
          const initializerFn = selfServMeta(inject(SelfServMetaCache));
          return initializerFn();
        }),

        {
          provide: APP_BOOTSTRAP_LISTENER,
          useFactory: serviceBootstrap,
          deps: STARTUP_SERVICES,
          multi: true,
        },
      ],
    };
  }
}
